import React from 'react';

import { TYPES } from '../../config/consignments';
import Consignments from '../../containers/Consignments';

export default function OutboundConsignments() {
  return <Consignments type={TYPES.OUTBOUND} />;
}
